
    import {
        defineComponent, PropType, ref, SetupContext, unref,
    } from 'vue';
    import { formatNumber } from '@ve/services/textModifiers';
    import DialogWrapperDesktop from '@ve/components/dialogWrapper/desktop/DialogWrapperDesktop.vue';
    import ButtonDesktop from '@ve/components/button/desktop/Button.vue';
    import useHotelOffersTariffPopup from '@ve/components/hotel/hotelOffersTariffsPopup/common/useHotelOffersTariffPopup';
    import useVueProxy from '@ve/services/useVueProxy';

    import { IHotelOfferTariff } from '../common/types';
    import HotelOfferTariff from '../common/HotelOfferTariff.vue';

    export default defineComponent({
        name: 'hotel-offers-tariff-popup',
        components: {
            HotelOfferTariff,
            ButtonDesktop,
            DialogWrapperDesktop,
        },
        props: {
            tariffs: {
                type: Array as PropType<IHotelOfferTariff[]>,
                required: true,
            },
        },
        setup(props) {
            const { $root } = useVueProxy();

            const {
                selectedTariff,
                changeTariff,
                currentTariff,
                quoteInProgress,
                createQuote,
            } = useHotelOffersTariffPopup(props, {
                ctx: $root,
            });

            const hotelOffersTariffPopup = ref(null);

            const open = () => {
                unref(hotelOffersTariffPopup)?.open();
            };

            const close = () => {
                unref(hotelOffersTariffPopup)?.close();
            };

            return {
                selectedTariff,
                open,
                close,
                hotelOffersTariffPopup,
                changeTariff,
                currentTariff,
                formatNumber,
                quoteInProgress,
                createQuote,
            };
        },
    });
